// Chakra imports
import {
  Box,
  RadioGroup,
  Radio,
  HStack,
  Stack,
  Heading,
  Input,
  Button,
  useOutsideClick,
  useDisclosure,
  VStack,
  Text,
  Icon,
  Grid,
  SimpleGrid,
} from "@chakra-ui/react";
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded";
import RingVolumeIcon from "@mui/icons-material/RingVolume";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import WifiCallingIcon from "@mui/icons-material/WifiCalling";
import ChatBox from "./components/ChatBox";
import { RadialChart } from "react-vis";
import { React, useEffect, useState, useRef } from "react";
import MiniCalendar from "components/calendar/MiniCalendar";

import { MdCall } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import {
  getTranscriptsData,
  putEditedTranscriptsData,
} from "../../../redux/actions/transcripts";
import {
  getAnalyticsDataAction,
  getAnalyticsCallBreakDownDataAction,
  getAnalyticsDataEveningAction,
  putEditAnalyticsDataAction,
  getAnalyticsDataActionINC,
  getAnalyticsCallBreakDownDataActionINC,
  getAnalyticsCallOverviewAction,
} from "../../../redux/actions/analytics";
// import { closeModal } from "../../../redux/actions/modal.js";
// import * as type from "../../../redux/types";
// import audioPlayer from "../../../assets/img/layout/audio-player.png";

import moment from "moment";
import { FiCalendar, FiPhoneOff } from "react-icons/fi";
// import Pagination from "./components/Pagination";
// import callSumUser from "../../../assets/img/profile/userImg.png";
import "./callVolume.css";

import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  {
    name: "Calls Attempted vs Calls Connected",
    Attempted: 4000,
    Connected: 2400,
    amt: 2400,
  },
];

const CustomBar = (props) => {
  const { fill, x, y, height } = props;
  const radius = 10; // Adjust the radius as needed
  const width = 20;

  return (
    <rect
      x={x}
      y={y}
      width={width}
      height={height}
      fill={fill}
      rx={radius}
      ry={false}
    />
  );
};

const UTC_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";

export default function CallVolume() {
  const calenderRef = useRef();
  const dispatch = useDispatch();
  const [selectedButton, setSelectedButton] = useState({
    isToday: false,
    is7days: false,
    is30Days: false,
    isCustom: false,
  });

  const [selectedDateRange, setSelectedDateRange] = useState({});
  const [dateFromCalendar, setDateFromCalendar] = useState(new Date());
  const userData = useSelector((state) => state.userData);
  const callBreakDownData = useSelector(
    (state) => state.analyticsData.callBreakDownData.callAnalytics
  );

  console.log("Call break down", callBreakDownData);
  useEffect(() => {
    // getTodaysData();
    getThirtyDaysData();
  }, []);
  useEffect(() => {
    if (dateFromCalendar?.length == 2) {
      //T23:59:00.000Z
      //console.log("dateFromCalendar",dateFromCalendar,  moment(dateFromCalendar[0]).format("YYYY-MM-DD"))

      setSelectedDateRange({
        ...selectedDateRange,
        startDate:
          moment(dateFromCalendar[0]).format("YYYY-MM-DD") + "T00:00:00.000Z",
        endDate:
          moment(dateFromCalendar[1]).utc().format("YYYY-MM-DD") +
          "T23:59:00.000Z",
      });
    }
  }, [dateFromCalendar]);

  console.log("Date range", selectedDateRange);
  const getTodaysData = () => {
    setSelectedButton({
      ...selectedButton,
      isToday: true,
      is7days: false,
      is30Days: false,
      isCustom: false,
    });
    setSelectedDateRange({
      ...selectedDateRange,
      startDate: moment()
        .utc()
        .set({ hours: "0", minutes: "0", seconds: "0" })
        .format(UTC_DATE_TIME_FORMAT),
      endDate: moment().utc().format(UTC_DATE_TIME_FORMAT),
    });
  };
  const getSevenDaysData = () => {
    setSelectedButton({
      ...selectedButton,
      is7days: true,
      isToday: false,
      is30Days: false,
      isCustom: false,
    });
    setSelectedDateRange({
      ...selectedDateRange,
      startDate: moment()
        .utc()
        .set({ hours: "0", minutes: "0", seconds: "0" })
        .subtract(6, "days")
        .format(UTC_DATE_TIME_FORMAT),
      endDate: moment().utc().format(UTC_DATE_TIME_FORMAT),
    });
  };

  const getThirtyDaysData = () => {
    setSelectedButton({
      ...selectedButton,
      isToday: false,
      is7days: false,
      is30Days: true,
      isCustom: false,
    });
    setSelectedDateRange({
      ...selectedDateRange,
      startDate: moment()
        .utc()
        .set({ hours: "0", minutes: "0", seconds: "0" })
        .subtract(30, "days")
        .format(UTC_DATE_TIME_FORMAT),
      endDate: moment().utc().format(UTC_DATE_TIME_FORMAT),
    });
  };

  const invokedGetAnalyticsApiDataCall = () => {
    dispatch(
      getAnalyticsCallOverviewAction({
        selectedDateRange,
        token: userData.token,
      })
    );
  };

  useEffect(() => {
    invokedGetAnalyticsApiDataCall();
  }, [selectedDateRange]);

  return (
    <Box
      className="main-page sbscoTranscriptContainer"
      style={{ marginTop: "5em" }}
    >
      <HStack m="0 10px 10px 0" className="sbscoHeadingRow">
        <Box w="100%">
          <Heading as="h4" size="md" noOfLines={1}>
            {/* {getHeaderTitle()} */}
            Customer call analytics
          </Heading>
        </Box>
        <div className="sbscoHeadingRight">
          <Box className="sbscoBtnGroup niclBtnGroupLeft">
            <Button
              onClick={() => {
                getTodaysData();
              }}
              size="sm"
              colorScheme={selectedButton.isToday ? "blue" : "gray"}
              variant={selectedButton.isToday ? "solid" : "outline"}
              border="1px"
            >
              Today
            </Button>
            <Button
              onClick={() => {
                getSevenDaysData();
              }}
              size="sm"
              colorScheme={selectedButton.is7days ? "blue" : "gray"}
              variant={selectedButton.is7days ? "solid" : "outline"}
              border="1px"
            >
              7 Days
            </Button>
            <Button
              onClick={() => {
                getThirtyDaysData();
              }}
              size="sm"
              colorScheme={selectedButton.is30Days ? "blue" : "gray"}
              variant={selectedButton.is30Days ? "solid" : "outline"}
              border="1px"
            >
              30 Days
            </Button>
          </Box>
          <Box className="niclBtnGroupRight">
            <div ref={calenderRef}>
              <VStack className="sbscoBtn">
                <Button
                  onClick={() => {
                    setSelectedButton({
                      ...selectedButton,
                      isToday: false,
                      is7days: false,
                      is30Days: false,
                      isCustom: true,
                    });
                    setDateFromCalendar(new Date());
                  }}
                  size="sm"
                  leftIcon={<FiCalendar />}
                  colorScheme={selectedButton.isCustom ? "blue" : "gray"}
                  variant={selectedButton.isCustom ? "solid" : "outline"}
                  border="1px"
                >
                  {dateFromCalendar?.length !== 2
                    ? "Date Range Selection"
                    : `${moment(dateFromCalendar[0]).format(
                        "YYYY-MM-DD"
                      )} to ${moment(dateFromCalendar[1]).format(
                        "YYYY-MM-DD"
                      )}`}
                </Button>
                {selectedButton.isCustom && dateFromCalendar?.length !== 2 ? (
                  <MiniCalendar
                    selectRange={true}
                    pos="absolute"
                    m="20px 0 0 0"
                    border="2px solid black"
                    zIndex="1"
                    transform="scale(0.6)"
                    transformOrigin="top"
                    dateFromCalendar={dateFromCalendar}
                    setDateFromCalendar={setDateFromCalendar}
                  />
                ) : null}
              </VStack>
            </div>
          </Box>
        </div>
      </HStack>

      {/* New Code */}

      {/* Heading Card */}
      <Box
        style={{ width: "100%" }}
        className="customerCallAnalytics headerCCA"
      >
        <SimpleGrid columns={{ sm: 1, md: 2, lg: 4 }} spacing="1.5rem">
          <Box bg="white" className="card card-1">
            <h5>
              Total Attempted
              <span>
                <PhoneForwardedIcon />
              </span>
            </h5>
            <h4>{callBreakDownData?.totalCallAttempt || 0}</h4>
          </Box>
          <Box bg="white" className="card card-2">
            <h5>
              Total Connected
              <span>
                <WifiCallingIcon />
              </span>
            </h5>
            <h4>{callBreakDownData?.successfulCall || 0}</h4>
          </Box>
          <Box bg="white" className="card card-3">
            <h5>
              Talk Time (min){" "}
              <span>
                <PhoneInTalkIcon />
              </span>
            </h5>
            <h4>{Math.round(callBreakDownData?.callDuration / 60) || "0"}</h4>
          </Box>
          <Box bg="white" className="card card-4">
            <h5>Ring Time (min)<span><RingVolumeIcon/></span></h5>
            <h4>{Math.round(callBreakDownData?.ringDuration / 60) || "0"}</h4>
          </Box>
        </SimpleGrid>
      </Box>
      {/* Body Card */}
      <Box style={{ width: "100%" }} className="customerCallAnalytics bodyCCA">
        <SimpleGrid columns={{ sm: 1, md: 2, lg: 3 }} spacing="1.5rem">
          <Box bg="white" className="card card-5">
            <h4>Calls Attempted vs Calls Connected</h4>
            <Box className="barChart">
              <BarChart
                barGap={100}
                width={500}
                height={300}
                data={[
                  {
                    name: "Calls Attempted vs Calls Connected",
                    Attempted: callBreakDownData?.totalCallAttempt,
                    Connected: callBreakDownData?.successfulCall,
                    amt: 2400,
                  },
                ]}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar
                  barSize={20}
                  radius={[20, 20, 0, 0]}
                  dataKey="Attempted"
                  fill="#ca0d9f"
                  width={20}
                  activeBar={<CustomBar fill="purple" stroke="purple" />}
                />
                <Bar
                  barSize={20}
                  radius={[20, 20, 0, 0]}
                  dataKey="Connected"
                  fill="#4387f6"
                  width={20}
                  activeBar={<CustomBar fill="blue" stroke="blue" />}
                />
              </BarChart>
            </Box>
          </Box>
          <Box bg="white" className="card card-6">
            <h4>Call duration less than 30s vs 60s vs 90s</h4>
            <Box className="barChart">
              <BarChart
                barGap={100}
                width={500}
                height={300}
                data={[
                  {
                    name: "30s vs 60s vs 90s",
                    callIDurationLT30SCall:
                      callBreakDownData?.callIDurationLT30SCall,
                    callIDurationLT60SCall:
                      callBreakDownData?.callIDurationLT60SCall,
                    callIDurationLT90SCall:
                      callBreakDownData?.callIDurationLT90SCall,
                    amt: 2400,
                  },
                ]}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar
                  barSize={20}
                  radius={[20, 20, 0, 0]}
                  dataKey="callIDurationLT30SCall"
                  fill="#ca0d9f"
                  width={20}
                  activeBar={<CustomBar fill="purple" stroke="purple" />}
                />
                <Bar
                  barSize={20}
                  radius={[20, 20, 0, 0]}
                  dataKey="callIDurationLT60SCall"
                  fill="#4387f6"
                  width={20}
                  activeBar={<CustomBar fill="blue" stroke="blue" />}
                />
                <Bar
                  barSize={20}
                  radius={[20, 20, 0, 0]}
                  dataKey="callIDurationLT90SCall"
                  fill="#green"
                  width={20}
                  activeBar={<CustomBar fill="green" stroke="green" />}
                />
              </BarChart>
            </Box>
          </Box>
          <Box bg="white" className="card card-7">
            <h4>Talk Time vs Total Ringing Time</h4>
            <Box className="barChart">
              <BarChart
                barGap={100}
                width={500}
                height={300}
                data={[
                  {
                    name: "Call duration vs ring duration",
                    callDuration: Math.round(
                      callBreakDownData?.callDuration / 60
                    ),
                    ringDuration: Math.round(
                      callBreakDownData?.ringDuration / 60
                    ),
                    amt: 2400,
                  },
                ]}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar
                  barSize={20}
                  radius={[20, 20, 0, 0]}
                  dataKey="callDuration"
                  fill="#ca0d9f"
                  width={20}
                  activeBar={<CustomBar fill="purple" stroke="purple" />}
                />
                <Bar
                  barSize={20}
                  radius={[20, 20, 0, 0]}
                  dataKey="ringDuration"
                  fill="#4387f6"
                  width={20}
                  activeBar={<CustomBar fill="blue" stroke="blue" />}
                />
              </BarChart>
            </Box>
          </Box>
        </SimpleGrid>
      </Box>
    </Box>
  );
}
